module.exports = __webpack_public_path__ + "static/media/office_11.42c14175.jpg";